export default __webpack_public_path__ + "static/media/close_white.d41f617c.svg";